import { httpClient } from './http-client';
import type { ApiResponse, PaginatedResponse } from './api.types';

export interface MedioPagoInfo {
  id: string;
  codigo: string;
  nombre: string;
}

export interface Caja {
  id: string;
  empresaId: string;
  nombre: string;
  observacion?: string;
  monedaCodigo?: string;
  monedaNombre?: string;
  establecimientoId: string;
  establecimientoCodigo?: string;
  establecimientoNombre?: string;
  medioPagos: MedioPagoInfo[];
  esHabilitada: boolean;
  limiteMaximo: number;
  margenDescuadre: number;
  tipoMargen: string;
  esDefecto: boolean;
  usuarioId?: string;
  usuarioNombre?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateCajaDTO {
  empresaId?: string;
  nombre: string;
  observacion?: string;
  monedaCodigo?: string;
  monedaNombre?: string;
  establecimientoId: string;
  establecimientoCodigo?: string;
  establecimientoNombre?: string;
  medioPagos: MedioPagoInfo[];
  esHabilitada?: boolean;
  limiteMaximo?: number;
  margenDescuadre?: number;
  tipoMargen?: string;
  esDefecto?: boolean;
}

export interface UpdateCajaDTO extends Partial<CreateCajaDTO> {
  id: string;
}

export const cajasService = {
  getAll: (params?: { page?: number; per_page?: number; search?: string; establecimientoId?: string }): Promise<ApiResponse<PaginatedResponse<Caja>>> => {
    return httpClient.get('/cajas', params);
  },

  getById: (id: string): Promise<ApiResponse<Caja>> => {
    return httpClient.get(`/cajas/${id}`);
  },

  getByEstablecimiento: (establecimientoId: string, params?: { page?: number; per_page?: number; search?: string }): Promise<ApiResponse<PaginatedResponse<Caja>>> => {
    return httpClient.get(`/cajas/establecimiento/${establecimientoId}`, params);
  },

  create: (data: CreateCajaDTO): Promise<ApiResponse<Caja>> => {
    return httpClient.post('/cajas', data);
  },

  update: (data: UpdateCajaDTO): Promise<ApiResponse<Caja>> => {
    return httpClient.put(`/cajas/${data.id}`, data);
  },

  delete: (id: string): Promise<ApiResponse<void>> => {
    return httpClient.delete(`/cajas/${id}`);
  },

  toggleStatus: (id: string): Promise<ApiResponse<Caja>> => {
    return httpClient.patch(`/cajas/${id}/toggle-status`);
  },
};
